import { useState } from "react";
import { Input } from "@/components/ui/input";
import { Switch } from "@/components/ui/switch";
import { Save, Trash2 } from "lucide-react";

const DAYS = [
  ["monday", "Lundi"], ["tuesday", "Mardi"], ["wednesday", "Mercredi"],
  ["thursday", "Jeudi"], ["friday", "Vendredi"], ["saturday", "Samedi"], ["sunday", "Dimanche"],
];

export function HoursEditor({ hours, onSave, testIdPrefix = "hours" }) {
  const [local, setLocal] = useState(hours || {});
  const setDay = (day, patch) => setLocal({ ...local, [day]: { ...local[day], ...patch } });
  const setRange = (day, idx, key, val) => {
    const ranges = [...(local[day]?.ranges || [])];
    ranges[idx] = { ...ranges[idx], [key]: val };
    setDay(day, { ranges });
  };
  const addRange = (day) => {
    const ranges = [...(local[day]?.ranges || []), { start: "09:00", end: "12:00" }];
    setDay(day, { ranges });
  };
  const removeRange = (day, idx) => {
    const ranges = (local[day]?.ranges || []).filter((_, i) => i !== idx);
    setDay(day, { ranges });
  };
  return (
    <div>
      <div className="space-y-3">
        {DAYS.map(([key, label]) => (
          <div key={key} className="bg-[#141311] border border-[#2C2A26] p-4" data-testid={`${testIdPrefix}-day-${key}`}>
            <div className="flex items-center justify-between mb-3">
              <div className="flex items-center gap-4">
                <span className="w-24 uppercase tracking-[0.2em] text-xs text-[#F4F0EA]">{label}</span>
                <Switch checked={local[key]?.open || false} onCheckedChange={(v) => setDay(key, { open: v, ranges: v && (!local[key]?.ranges?.length) ? [{ start: "09:00", end: "18:00" }] : local[key]?.ranges })} data-testid={`${testIdPrefix}-open-${key}`} />
                <span className="text-xs text-[#A39E93]">{local[key]?.open ? "Ouvert" : "Fermé"}</span>
              </div>
              {local[key]?.open && (
                <button onClick={() => addRange(key)} className="text-[#C5A059] text-xs uppercase tracking-[0.2em]" data-testid={`${testIdPrefix}-add-range-${key}`}>+ Plage</button>
              )}
            </div>
            {local[key]?.open && (local[key].ranges || []).map((r, i) => (
              <div key={i} className="flex items-center gap-3 mt-2">
                <Input type="time" value={r.start} onChange={(e)=>setRange(key,i,"start",e.target.value)} className="bg-[#0A0908] border-[#2C2A26] w-32" data-testid={`${testIdPrefix}-${key}-start-${i}`} />
                <span className="text-[#6B6760]">→</span>
                <Input type="time" value={r.end} onChange={(e)=>setRange(key,i,"end",e.target.value)} className="bg-[#0A0908] border-[#2C2A26] w-32" data-testid={`${testIdPrefix}-${key}-end-${i}`} />
                <button onClick={() => removeRange(key, i)} className="text-[#8C3131]" data-testid={`${testIdPrefix}-${key}-remove-${i}`}><Trash2 className="w-4 h-4" strokeWidth={1.5} /></button>
              </div>
            ))}
          </div>
        ))}
      </div>
      <button onClick={() => onSave(local)} className="btn-primary mt-6" data-testid={`${testIdPrefix}-save`}>
        <Save className="w-4 h-4" strokeWidth={1.5} /> Enregistrer les horaires
      </button>
    </div>
  );
}
